import * as React from 'react';
import Project from 'src/entities/Project';
import ProjectCardComponent from './partials/ProjectCard.component';
import ProjectSimpleCardComponent from './partials/ProjectSimpleCard.component';
// import 'owl.carousel/dist/assets/owl.carousel.css';
// import 'owl.carousel/dist/assets/owl.theme.default.css';
// import OwlCarousel, { Options } from 'react-owl-carousel';
import TinySlider from 'tiny-slider-react';
import 'ventura-slider/dist/tiny-slider.css';

export interface Props {
  projects: Project[];
  numberOfItems: number;
  isSimple: boolean;
  status: string;
  carousel: boolean;
}

export interface State {
  projects: Project[];
}

class ProjectListComponent extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      projects: props.projects
    };
  }

  public componentWillReceiveProps(nextProps: Props): void {
    if (nextProps.projects.length !== this.state.projects.length) {
      this.setState({ 
        projects: nextProps.projects 
      });
    }
  }

  public shouldComponentUpdate(nextProps: Props): boolean {
    if (this.props.projects.length !== nextProps.projects.length) {
      return true;
    }

    return false;
  }

  public render(): React.ReactNode {
    return (
      <section>
        {this.props.carousel && this.state.projects.length ? (
          <TinySlider 
            settings={{
              nav: false,
              controls: false,
              mouseDrag: true,
              gutter: 10,
              items: this.props.numberOfItems,
              loop: true,
              autoplay: true,
              autoplayButtonOutput: false,
              responsive: {
                0: {
                  items: 1,
                  // nav: true
                },
                600: {
                  items: 2,
                  // nav: false
                },
                800: {
                  items: 3,
                  // nav: false
                },
                1100: {
                  items: 4,
                  // nav: true,
                  loop: false
                }
              }
            }}
          >
            {this.state.projects.map(
              (project, key) => (
                <div
                  className="item"
                  key={key}
                >
                  {this.props.isSimple ?
                    <ProjectSimpleCardComponent project={project}/> :
                    <ProjectCardComponent
                      project={project}
                      status={this.props.status}
                    />
                  }
                </div>
              )
            )}
          </TinySlider>
          ) : (
          <section>
            {this.props.projects.map(
              (project, key) => (
                <div key={key}>
                  {this.props.isSimple ?
                    <ProjectSimpleCardComponent project={project}/> :
                    <ProjectCardComponent
                      project={project}
                      status={this.props.status}
                    />
                  }
                </div>
              )
            )}
          </section>
          )
        }
      </section>
    );
  }
}

export default ProjectListComponent;


// WEBPACK FOOTER //
// ./src/modules/projects/ProjectList.component.tsx